export default __webpack_public_path__ + "static/media/dylan.396e9620.jpg";